import * as React from "react";
import { RatingProps } from "@mui/material/Rating";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { useLanguage } from "../Language";
import { ReviewService } from "../ReviewService";
import { RatingHighContrast } from "./RatingHighContrast";
import { ResourceDWR } from "../../dto/ResourceDWR";
import { useReviewDialog } from "../../contexts/ReviewDialogContext";
import { ResourceView } from "../../dto/ResourceView";

interface RateAndReviewProps extends RatingProps {
  material: ResourceDWR | ResourceView;
  ratingOnly?: boolean;
}

export function RateAndReview({
  material,
  ratingOnly = false,
  ...props
}: RateAndReviewProps) {
  const resourceId = material.id;
  const { showReviewDialog } = useReviewDialog();
  const [open, setOpen] = React.useState<boolean>(false);
  const [rating, setRating] = React.useState<number | null>(
    material?.ratingInformation?.average
  );
  const { translate } = useLanguage();

  if (material.rtype !== 1) return;

  const handleClose = () => {
    setOpen(false);
  };

  const handleReview = () => {
    setOpen(false);
    showReviewDialog(material, rating);
  };

  // action will be undefined if ratingOnly is true
  const action = !ratingOnly && (
    <Button color="inherit" onClick={handleReview} size="small">
      {translate("writeAFullReviewQuestion")}
    </Button>
  );

  const successMessage = translate("ratingHasBeenSaved");

  const handleRatingChange = async (
    event: React.ChangeEvent<{}>,
    newValue: number | null
  ) => {
    if (newValue !== null) {
      try {
        const { success } = await ReviewService.addRating(resourceId, newValue);
        if (!success) {
          return;
        }
        setOpen(true);
        const { average } = await ReviewService.getRatingInformation(
          resourceId
        );
        setRating(average);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <div>
      <RatingHighContrast
        name="rating"
        {...props}
        value={rating}
        onChange={handleRatingChange}
        precision={0.5}
      />
      {/* TODO update useToast showToast to accept an action? */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
          action={action}
        >
          {successMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
